// Require here all assets which needs to be processed by webpack loaders/plugins

const requireIcons = require.context('./assets/icons', true, /\.svg$/);
requireIcons.keys().forEach(requireIcons);



// WEBPACK FOOTER //
// ./src/assets.js